import { render, staticRenderFns } from "./AppHelperButton.vue?vue&type=template&id=55f35c51&"
import script from "./AppHelperButton.vue?vue&type=script&lang=js&"
export * from "./AppHelperButton.vue?vue&type=script&lang=js&"
import style0 from "./AppHelperButton.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports